import React, {useMemo} from 'react'

import {Filter, FilterParams, ToggleMatchingFilter, getCount} from '../../libs/table-row-filter'

import FilterToggle from '../../../../commons/src/components/filter-toggle'

type Props<TableRow> = {
  label: string
  filterKey: string
  filterMap: Record<string, Filter<TableRow, FilterParams<TableRow>>>
  tableRows: TableRow[]
  applyFilter: (newFilter: ToggleMatchingFilter<TableRow>) => void
}

const ToggleMatchingFilterPartial = <TableRow extends unknown>({
  label,
  filterKey,
  filterMap,
  tableRows,
  applyFilter,
}: Props<TableRow>) => {
  const filter = filterMap[filterKey] as ToggleMatchingFilter<TableRow>

  const checked = filter.serialize().filterValue

  const memoizedCount = useMemo(
    () =>
      filter
        ? getCount(
            tableRows,
            filterMap,
            filterKey,
            new ToggleMatchingFilter({
              ...filter.serialize(),
              filterValue: true,
            })
          )
        : 0,
    [tableRows, filterMap, filterKey]
  )

  const handleOnChange = (value: boolean) => {
    applyFilter(
      new ToggleMatchingFilter({
        ...filter.serialize(),
        filterValue: value,
      })
    )
  }

  const filterLabel = memoizedCount > 0 ? `${label} (${memoizedCount})` : label

  return <FilterToggle label={filterLabel} checked={checked} onChange={handleOnChange} />
}

export default ToggleMatchingFilterPartial
